var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DsConfirmDialog',{attrs:{"is-open":_vm.isOpen,"title":_vm.$t('funnel.edit.lightbox.campaign.delete'),"message":_vm.$t('funnel.edit.delete.confirmation'),"confirm-label":_vm.$t('funnel.edit.lightbox.delete'),"cancel-label":_vm.$t('funnel.edit.cancel')},on:{"cancel":_vm.closeDeleteCampaignModal,"confirm":_vm.deleteCampaign}})
}
var staticRenderFns = []

export { render, staticRenderFns }